{
  "nl": {
    "worksheet": {
      "autoSave": {
        "saved": "Wijzigingen opgeslagen",
        "saveFailed": "Wijzigingen konden niet worden opgeslagen",
        "sessionExpired": "Je sessie is verlopen. Log opnieuw in om wijzigingen op te slaan.",
        "draftRestoreFailed": "Concept kon niet worden hersteld"
      },
      "submitFailed": "Inleveren mislukt. Probeer het opnieuw.",
      "aiGenerator": {
        "breadcrumbs": {
          "course": "Cursus",
          "knowledge": "Kennis",
          "topic": "Onderwerp"
        },
        "buttons": {
          "createWorksheet": "Werkblad maken",
          "creating": "Verwerking bezig …"
        },
        "course": {
          "grade": "Klasniveau",
          "language": "Taal",
          "school": "Schooltype",
          "subject": "Schoolvak"
        },
        "errors": {
          "generationFailed": "Het werkblad kon niet worden aangemaakt. Probeer het opnieuw."
        },
        "headers": {
          "createTitle": "Werkblad met AI-Assistentie aanmaken"
        },
        "knowledge": {
          "subtitle": "Optioneel kun je een bron toevoegen waaruit de AI de achtergrondkennis voor het werkblad haalt."
        },
        "labels": {
          "languageLevel": "Taalniveau (ERK) selecteren",
          "learningObjectiveHeading": "Leerdoel voor dit werkblad",
          "topicHeading": "Onderwerp of vraagstelling voor dit werkblad"
        },
        "placeholders": {
          "learningObjectiveHeading": "Welke competenties moeten worden opgebouwd? (bijv. analyse en beoordeling van de startomstandigheden van de Weimarrepubliek).",
          "topicHeading": "Welke hoofdonderwerpen moet het werkblad behandelen? (bijv. 'Het begin van de Weimarrepubliek')"
        },
        "tooltips": {
          "generateLearningObjectives": "Leerdoelen laten voorstellen door AI",
          "generateLearningObjectivesDisabled": "Voer eerst een onderwerp in om leerdoelen te laten voorstellen"
        }
      },
      "aiPromptModal2": {
        "headers": {
          "title": "Tekstopdracht genereren met AI"
        },
        "labels": {
          "prompt": "Vereisten"
        },
        "placeholders": {
          "prompt": "Beschrijf de focus van de opdracht en geef eventueel een hoofdvraag of leerdoel aan."
        },
        "description": "Wat wil je maken?"
      },
      "aiGeneration": {
        "createWithAi": "Maken met AI",
        "dropdownLabel": "AI-opties voor genereren",
        "pending": "AI maakt inhoud...",
        "menu": {
          "newVariant": "Inhoud variëren",
          "harder": "Moeilijkere opdracht",
          "easier": "Eenvoudigere opdracht",
          "addHelp": "Aanwijzingen toevoegen",
          "simpleLanguage": "Eenvoudige taal",
          "custom": "Eigen verzoek"
        },
        "prompts": {
          "newBlock": "Maak een passend {blockType}-blok als volgende logische stap in dit werkblad.",
          "newVariant": "Maak een variant van dit blok: verander context, getallen of formulering zodat de opgave niet uit het hoofd kan worden opgelost. Leerdoel en moeilijkheidsgraad blijven hetzelfde.",
          "harder": "Maak dit blok uitdagender door meer denkwerk te vragen – niet meer werk.",
          "easier": "Maak dit blok eenvoudiger: vereenvoudig taal en structuur en verwijder overbodige informatie. Leerdoel en vaktermen blijven – leg vaktermen uit in plaats van ze te vervangen.",
          "addHelp": "Voeg nuttige aanwijzingen, tussenstappen of voorbeelden toe zonder de oplossing weg te geven.",
          "simpleLanguage": "Formuleer dit blok in eenvoudige taal. Behoud vaktermen uit het leerdoel en blok en leg ze indien nodig uit.",
          "guidance": {
            "fillInTheBlank": "Voor invultekst: vul beschrijving en invultekst in; varieer de gaten passend bij de vraag."
          }
        }
      },
      "aiContext": {
        "title": "AI-Werkbladinstellingen",
        "button": "AI-instellingen",
        "description": "Bepaal hier voor wie het werkblad is. Met deze informatie kan de AI beter taken voor je maken.",
        "sections": {
          "schoolDetails": {
            "title": "Schoolgegevens"
          },
          "backgroundKnowledge": {
            "title": "Achtergrondkennis"
          }
        },
        "labels": {
          "subjectTypes": "Schoolvak",
          "schoolTypes": "Schooltype",
          "gradeLevels": "Klasniveau",
          "locale": "Taal",
          "addBackgroundKnowledge": "Achtergrondkennis toevoegen"
        },
        "descriptions": {
          "addBackgroundKnowledge": "Voeg achtergrondkennis uit verschillende bronnen toe, bijvoorbeeld via bestandsupload en van websites, YouTube-video's, audiobestanden of video's."
        },
        "actions": {
          "removeSource": "Bron verwijderen"
        },
        "hints": {
          "hasSources": "Bronnen aanwezig"
        },
        "sourceKinds": {
          "text": "Tekst",
          "file": "Bestand",
          "pdf": "PDF",
          "image": "Afbeelding",
          "website": "Website",
          "youtube": "YouTube",
          "audio": "Audio",
          "video": "Video"
        },
        "flash": {
          "saveFailed": "AI-instellingen konden niet worden opgeslagen"
        },
        "sourcePicker": {
          "title": "Achtergrondkennis toevoegen",
          "subtitle": "Kies een bron en de AI extraheert daaruit de tekst als achtergrondkennis voor het werkblad."
        },
        "recent": {
          "empty": "Nog geen bronnen aanwezig. Voeg eerst achtergrondkennis toe.",
          "error": "De laatst gebruikte bronnen konden niet worden geladen."
        }
      },
      "blockTypes": {
        "Divider": "Scheidingslijn",
        "File": "Bestand",
        "FillInTheBlankText": "Gatentekst",
        "H5p": "H5P",
        "Hint": "Tip",
        "Image": "Afbeelding",
        "MultipleChoice": "Meerkeuze",
        "SingleChoice": "Enkele keuze",
        "Spacer": "Afstand",
        "PageBreak": "Pagina-einde",
        "StaticText": "Tekst",
        "Text": "Tekstantwoord",
        "Upload": "Bestand aanvragen",
        "Video": "Video",
        "ToTeachExercise": "to teach oefening"
      },
      "blockTypesV2": {
        "Upload": "Bestand aanvragen",
        "ToTeachExercise": "to teach oefening"
      },
      "inserterHints": {
        "toTeachExercise": "Nieuw: gebruik je inhoud van to teach in je fobizz werkbladen.",
        "pageBreak": "Nieuw: Focus de weergave door paginascheidingen."
      },
      "navigation": {
        "headline": "Jouw voortgang",
        "previousPage": "Terug",
        "nextPage": "Volgende pagina"
      },
      "buttons": {
        "addOption": "Optie toevoegen",
        "submit": "Inleveren",
        "confirmDelete": "Ja, verwijderen",
        "duplicate": "Dupliceren",
        "generate": "Genereren",
        "deleteResponse": "Inlevering verwijderen",
        "moveDown": "Naar beneden verplaatsen",
        "moveUp": "Naar boven verplaatsen",
        "remove": "Verwijderen",
        "removeOption": "Optie verwijderen"
      },
      "elements": "Elementen",
      "addNewBlock": "Nieuw blok toevoegen",
      "multimedia": "Multimedia",
      "layout": "Lay-out",
      "feedback": {
        "form": {
          "actions": {
            "reset": {
              "label": "Feedback verwijderen",
              "message": {
                "success": "Feedback verwijderd"
              }
            },
            "submit": {
              "label": "Feedback opslaan",
              "message": {
                "error": "Feedback kon niet worden opgeslagen",
                "success": "Feedback opgeslagen"
              }
            }
          },
          "fieldset": {
            "text": {
              "label": "Tekstbericht schrijven"
            }
          },
          "headline": "Individuele feedback geven"
        },
        "public": {
          "headline": "Feedback van {name} op je inzending"
        },
        "shareLinkBox": "Deel link naar inzending met feedback",
        "status": {
          "hasFeedback": "Feedback gegeven"
        }
      },
      "fillInTheBlankDefault": {
        "answerOption": "Dit is een voorbeeld van een invultekst met een {'{'} gat {'}'}. Er kunnen {'{'} veel/meerdere/verschillende {'}'} antwoordmogelijkheden worden opgegeven. In dit geval is 'gat' het juiste antwoord in de eerste zin. In de tweede zin zijn zowel 'veel' als 'meerdere' en 'verschillende' correct.",
        "description": "Jouw beschrijvingstekst met instructies voor de verwerking (niet de invultekst). Je kunt hier ook oplossingssuggesties voor de toewijzing aanbieden, bijvoorbeeld zo: 'Vul de invultekst aan met de volgende begrippen: <i><mark>Woord 1</mark></i>, <i><mark>Woord 2</mark></i>...'"
      },
      "fillInTheBlankEditor": {
        "descriptionLabel": "Beschrijvingstekst",
        "descriptionHint": "Gebruik de beschrijvingstekst voor verwerkingsinstructies. Je kunt hier ook oplossingssuggesties voor de toewijzing aanbieden. Bijvoorbeeld {italic}",
        "descriptionHintItalic": "\"Vul de invultekst aan met de volgende begrippen: Duitsland, deelstaat, republiek,...\"",
        "clozeLabel": "Invultekst",
        "clozeHint": "\"Voorbeeld van een invultekst met een <strong>{'{'} gat {'}'}</strong>. Er kunnen <strong>{'{'} veel/meerdere {'}'}</strong> antwoorden worden vastgelegd.\" In dit geval is 'gat' het juiste antwoord en in de tweede zin zijn zowel 'veel' als 'meerdere' correct.",
        "insertGap": "Gat invoegen"
      },
      "flash": {
        "addOptionSuccess": "Optie toegevoegd",
        "createBlockSuccess": "Blok toegevoegd",
        "createSolutionSuccess": "Oplossing toegevoegd",
        "deleteBlockSuccess": "Blok verwijderd",
        "duplicateBlockSuccess": "Blok gedupliceerd",
        "deleteOptionSuccess": "Optie verwijderd",
        "deleteSolutionSuccess": "Oplossing verwijderd",
        "moveBlockSuccess": "Blok verplaatst",
        "updateBlockSuccess": "Blok bijgewerkt",
        "updateClozeTestSuccess": "Invultekst bijgewerkt",
        "updateOptionSuccess": "Optie bijgewerkt",
        "updateSolutionSuccess": "Oplossing bijgewerkt",
        "updateWorksheetSuccess": "Werkblad bijgewerkt",
        "updateWorksheetError": "Werkblad kon niet worden bijgewerkt"
      },
      "headings": {
        "saveShareLink": "Bewaar deze link om je resultaten later gemakkelijk terug te vinden."
      },
      "hints": {
        "Divider": "Gebruik de scheidingslijn om het werkblad visueel te structureren en een gedeelte van het volgende af te bakenen.",
        "File": "Voeg hier werkmateriaal toe (bijv. een tekstbestand, een afbeelding of een pdf) dat je leerlingen moeten downloaden of bekijken. Tip: gebruik het uploadtaakblok om het bewerkte bestand direct weer van je leerlingen te verzamelen.",
        "FillInTheBlankText": "Schrijf een invultekst of een vraag met één antwoordgat. Gebruik de symbolen {'{'} en {'}'} om een gat te markeren en de mogelijke oplossingswoorden te omsluiten. Als meer dan één woord correct kan zijn, scheid de oplossingswoorden met een /. Een voorbeeldzin zou kunnen luiden: \"De leerlingen moeten {'{'}een/de{'}'} gat invullen.\" Hier is zowel 'een' als 'de' een correct antwoord. Alle antwoorden worden direct beoordeeld.",
        "H5p": "Voeg interactieve H5P-inhoud toe aan je werkblad. Upload een .h5p-bestand om interactieve oefeningen, quizzen en leerspellen te maken.",
        "Hint": "Geef je leerlingen extra tips met deze visueel gemarkeerde tekstnotitie.",
        "Image": "Voeg een afbeelding uit de afbeeldingzoeker toe of upload een eigen afbeelding om je werkblad te verrijken met visuele inhoud.",
        "MultipleChoice": "Stel een vraag en voer de antwoordmogelijkheden in. Markeer de juiste antwoorden door op de cirkel ervoor te klikken. De evaluatie toont je direct bij welke taken je leerlingen de grootste zekerheid – of de grootste herhalingsbehoefte – hebben.",
        "SingleChoice": "Stel een vraag en voer de antwoordmogelijkheden in. Markeer het juiste antwoord door op de cirkel ervoor te klikken. De evaluatie toont je direct bij welke taken je leerlingen de grootste zekerheid – of de grootste herhalingsbehoefte – hebben.",
        "Spacer": "Voeg afstanden toe aan je werkblad om de inhoud overzichtelijker te maken.",
        "PageBreak": "Gebruik de paginabreuk om het werkblad in meerdere pagina's te verdelen waartussen genavigeerd kan worden.",
        "StaticText": "Gebruik het tekstelement om je leerlingen uitleg, aanwijzingen en extra info te geven voor het maken van de opdrachten. Let op: hier kunnen je leerlingen - in tegenstelling tot bij de vraagblokken - niets digitaal invullen.",
        "Text": "Stel een werkopdracht op waarvoor je leerlingen een antwoord in een tekstveld digitaal kunnen indienen.",
        "Upload": "Formuleer een werkopdracht waarvoor je leerlingen een bestand moeten uploaden (bijv. een tekstbestand, een afbeelding of een pdf). Je kunt later alle ingediende bestanden op één plek overzichtelijk beoordelen.",
        "ToTeachExercise": "Zoek naar interactieve oefeningen van to teach en voeg ze direct toe aan je werkblad.",
        "Video": "Voeg YouTube- of Vimeo-video's in via link (bijv.: https://vimeo.com/469669139).",
        "answered": "beantwoord",
        "dragNDrop": "Tip: je kunt een bestand direct uploaden via drag & drop",
        "dropFileHere": "Sleep hier een bestand naartoe of kies een bestand",
        "dropH5pFileHere": "Sleep hier een H5P-bestand naartoe of",
        "uploadH5pFilePrompt": "Sleep hier een H5P-bestand naartoe of kies een bestand",
        "elements": "Voeg uitleg en inhoud voor je leerlingen toe en structureer je werkblad.",
        "h5pContentStatus": "Status: {status}",
        "h5pFileRequirement": "Alleen .h5p-bestanden zijn toegestaan",
        "h5pProcessing": "H5P-inhoud wordt verwerkt, even geduld...",
        "h5pProcessingFailed": "H5P-verwerking mislukt. Probeer het opnieuw.",
        "h5pProcessingStalled": "De verwerking van deze H5P-inhoud duurt ongewoon lang. Probeer het later opnieuw of neem contact op met de ondersteuning.",
        "h5pReloadHint": "Wordt de inhoud niet weergegeven? Pagina opnieuw laden",
        "h5pFileUploadSuccess": "H5P-bestand succesvol geüpload.",
        "h5pPreviewHint": "In de voorbeeldweergave kun je de module uitproberen.",
        "toTeachExerciseImportSuccess": "to teach oefening succesvol geïmporteerd.",
        "maxOptionsReached": "Er kunnen maximaal {max} opties worden toegevoegd.",
        "name": "Voer hier je pseudoniem of naamafkorting in.",
        "noDescriptionOrCloze": "Geen beschrijving en geen invultekst opgegeven",
        "emptyBlock": "<strong>Dit blok is leeg.</strong> Het wordt niet weergegeven in de voorbeeldweergave of in de weergave voor leerlingen.",
        "noDescriptionOrOptions": "Geen beschrijving of opties opgegeven",
        "fileUploadSuccess": "Bestand succesvol geüpload.",
        "noFile": "Geen bestand geüpload",
        "noH5pContent": "Geen H5P-inhoud geüpload",
        "h5pNotPrintable": "Deze interactieve inhoud kan niet worden afgedrukt.",
        "noHint": "Geen tip ingevoerd",
        "noImage": "Geen afbeelding geüpload",
        "noInput": "Geen opgave",
        "selectFile": "Bestand selecteren",
        "noSolution": "Geen oplossing opgegeven",
        "noText": "Geen tekst ingevoerd",
        "noVideo": "Geen video ingesloten",
        "processingH5pFile": "H5P-bestand wordt verwerkt...",
        "questions": "Maak taken met velden die je leerlingen kunnen invullen.",
        "submitSuccessful": "Hartelijk dank! Je hebt je werkblad succesvol ingeleverd.",
        "searchToTeachExercises": "to teach oefeningen zoeken...",
        "processingToTeachExercise": "to teach oefening wordt geïmporteerd en verwerkt...",
        "noToTeachExercisesFound": "Geen oefeningen gevonden",
        "noToTeachExercise": "Geen to teach oefening geselecteerd",
        "toTeachSsoNotLinked": "Je account is nog niet gekoppeld aan to teach. Koppel je account om je to teach-inhoud bij fobizz te gebruiken. <a href=\"https://to-teach.ai/auth/fobizz\" target=\"_blank\" rel=\"noopener noreferrer\">Naar to teach</a>",
        "videoError": "De ingevoerde URL is ongeldig. Voer een correct adres in of verwijder je invoer.",
        "videoExample": "Voorbeeld: https://vimeo.com/469669139"
      },
      "labels": {
        "clozeGap": "Gat {current} van {total}",
        "confirmDeleteBlock": "Blok verwijderen?",
        "confirmDeleteBlockText": "Let op: als je dit blok verwijdert, worden alle eventueel daaraan gekoppelde inzendingen ook verwijderd.",
        "confirmDeleteResponse": "Inzending echt verwijderen?",
        "confirmDeleteResponseText": "Moet de inzending echt worden verwijderd?",
        "confirmSubmitIncompleteResponse": "Niet alle opdrachten zijn nog bewerkt. Wil je het werkblad toch inleveren?",
        "confirmSubmitResponse": "Wil je het werkblad nu inleveren?",
        "confirmSubmitResponseTitle": "Werkblad inleveren?",
        "confirmSubmitKeepEditing": "Verder bewerken",
        "confirmSubmitAnyway": "Ja, inleveren",
        "draft": "Concept | Concepten",
        "response": "Inzending | Inzendingen",
        "responseStatus": {
          "draft": "In bewerking",
          "submitted": "Afgerond"
        },
        "respondingAs": "Je beantwoordt dit werkblad als {pseudonym}",
        "responsesTab": "Concepten en inzendingen",
        "worksheet": "Werkblad"
      },
      "links": {
        "shareResponse": "Toegangslink kopiëren",
        "showResponseSolutionToggle": "Toon modeloplossingen",
        "taskNo": "{ index }. Opdracht"
      },
      "placeholders": {
        "FillInTheBlankText": "Voer hier de gatentekst in",
        "answerInput": "Voer hier het antwoord in",
        "clickToEdit": "Klik om te bewerken",
        "description": "Voer hier de beschrijving in",
        "hint": "Voer hier de tip in",
        "imageCaption": "Voer hier het bijschrift in",
        "optionInput": "Voer hier de optie in",
        "videoCaption": "Voer hier het videobijschrift in",
        "videoUrl": "Voer de video-URL in"
      },
      "questions": "Vragen",
      "solution": {
        "actions": {
          "add": "Modeloplossing toevoegen",
          "delete": "Modeloplossing verwijderen",
          "showResponseSolution": "Alle oplossingen na inzending tonen"
        },
        "hints": {
          "showResponseSolution": "Je leerlingen zien de opgeslagen modeloplossingen direct na inzending."
        },
        "title": "Modeloplossing",
        "types": {
          "text": {
            "placeholder": "Modeloplossing hier invoeren..."
          }
        }
      },
      "words": {
        "of": "door"
      },
      "h5pForm": {
        "question": "Vraag",
        "statement": "Stelling",
        "statementCorrect": "De stelling is juist",
        "task": "Opdracht",
        "sentence": "Zin {number}",
        "sentencesHint": "Markeer gaten met een sterretje, bijv. De zon is een *ster*. Meerdere juiste antwoorden scheid je met /, bijv. *ster/vaste ster*.",
        "option": "Antwoord {number}",
        "optionCorrect": "Antwoord {number} is juist",
        "addOption": "Antwoord toevoegen",
        "removeOption": "Antwoord verwijderen",
        "addSentence": "Zin toevoegen",
        "removeSentence": "Zin verwijderen",
        "questionNumber": "Vraag {number} van {count}",
        "removeQuestion": "Vraag verwijderen",
        "addQuestion": {
          "multiChoice": "Meerkeuzevraag toevoegen",
          "trueFalse": "Juist-of-onjuist-vraag toevoegen",
          "blanks": "Gatentekst toevoegen"
        },
        "kinds": {
          "multiChoice": "Meerkeuze",
          "trueFalse": "Juist of onjuist",
          "blanks": "Gatentekst"
        },
        "autosaved": "Wijzigingen worden automatisch opgeslagen en overgenomen bij het verlaten van het blok.",
        "rebuilding": "Wordt bijgewerkt …",
        "errorsTitle": "De oefening kan niet worden overgenomen:",
        "publishFailed": "De oefening kon niet worden bijgewerkt. Je wijzigingen zijn opgeslagen.",
        "replaceFile": "Vervangen door H5P-bestand",
        "backToForm": "Terug naar het formulier",
        "replaceConfirm": {
          "title": "H5P-oefening vervangen?",
          "text": "De huidige oefening en je nog niet overgenomen wijzigingen worden vervangen door het geüploade bestand.",
          "confirm": "Bestand uploaden"
        },
        "answer": "Oplossingswoord {number}",
        "clue": "Tip {number}",
        "crosswordHint": "Elk oplossingswoord is een enkel woord van letters, zonder spaties. De puzzel rangschikt de woorden zelf.",
        "word": "Woord {number}",
        "findTheWordsHint": "De woorden worden verborgen in het letterraster. Elk woord mag slechts één keer voorkomen.",
        "addWord": "Woord toevoegen",
        "removeWord": "Woord verwijderen",
        "dragText": "Tekst",
        "dragTextHint": "Zet elk woord om te slepen tussen sterretjes, bijv. De hoofdstad is *Berlijn*. Een tip schrijf je na een dubbele punt: *Berlijn:ligt aan de Spree*.",
        "distractors": "Afleiders",
        "distractorsHint": "Extra foute woorden om te slepen, elk tussen sterretjes, bijv. *Hamburg* *Donau*. Mag leeg blijven."
      },
      "h5pInserter": {
        "title": "Interactieve oefeningen (H5P)",
        "upload": "H5P uploaden",
        "types": {
          "questionSet": "Quiz",
          "crossword": "Kruiswoordpuzzel",
          "findTheWords": "Woordzoeker",
          "dragText": "Woorden slepen"
        }
      }
    }
  }
}
